import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import {Helmet} from "react-helmet";

class ProjectsPage extends Component {
	componentWillMount() {
		document.body.className = 'projects'
	}

	render() {
		return (
			<main>
				<Helmet>
					<title>Projects | Tokariev Sviatoslav's workshop</title>
				</Helmet>
				<h1 className="heading--projects">Projects</h1>
				<div className="projects__wrapper">
					{this.props.projects.map((item, key) => {
						return (
							<article className="projects__item" key={key}>
								<div className="projects__image">
									<img src={item.preview.image.src} alt={item.preview.image.alt}/>
								</div>
								<div className="projects__description">
									<div>
										<h2 className="projects__heading">{item.heading}</h2>
										<span className="projects__subheading">
											{item.preview.technologies.map((tech, k, arr)=>{
												if(k===arr.length-1){
													return <span key={k}>{tech}</span>
												}
												return (
													<span key={k}>{tech}<span className="delimeter">/</span></span>
												)
											})}
										</span>
										<p className="projects__text">
											{item.preview.text}
										</p>
									</div>
									<div className="projects__buttons">
										<Link className="button--pink" to={"projects/"+item.title}>
											Read more
										</Link>
										{item.project.link?<a className="button--bordered" href={item.project.link} target="_blank">
											To project
										</a>:null}
									</div>
								</div>
							</article>
						)
					})}
				</div>
			</main>
		)
	}

}

export default ProjectsPage



// WEBPACK FOOTER //
// ./src/containers/ProjectsPage.js